module.exports = __webpack_public_path__ + "static/media/ic_疾病码分类.88fb13bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_疾病码分类.svg
// module id = 341
// module chunks = 0